const musicLinkUrlPartsIT = {
    "view": {
        "table": {
            "title": "La tua lista di parti URL dei link musicali",
            "column": {
                "part": "Parte",
                "owner": "Proprietario",
                "action": "Azione"
            },
            "placeholder": {
                "search": "Cerca..."
            },
            "button": {
                "exportCSV": "Esporta CSV"
            }
        },
        "message": {
            "success": "La parte URL del link musicale è stata rimossa!",
            "error": "Qualcosa è andato storto! Si prega di aggiornare la pagina e riprovare!",
            "noUrlparts": "Attualmente questa funzione è offerta solo a pochi utenti selezionati, ma la buona notizia è che presto potrai utilizzarla anche tu. Continua a seguire questo spazio!"
        },
        "modal": {
            "delete": {
                "header": "Eliminare {{mlUrlpart}}?",
                "body": "Sei sicuro di voler eliminare questa parte URL del link musicale?"
            },
            "canNotDelete": {
                "header": "Impossibile eliminare la parte URL del link musicale {{mlUrlPart}}",
                "body": "La parte URL del link musicale {{mlUrlPart}} non può essere eliminata poiché è già associata a un link musicale."
            }
        }
    },
    "add": {
        "form": {
            "label": {
                "subUser": "Sotto-utente",
                "part": "Parte",
                "owner": "Proprietario",
                "addUrlPart": "Aggiungi parte URL",
                "editUrlPart": "Modifica parte URL"
            },
            "placeholder": {
                "subUser": "Seleziona sotto-utente..."
            },
            "help_text": {
                "subUser": "Nota: Usa questo menu a tendina solo se vuoi aggiungere un link musicale per uno dei tuoi sotto-utenti, altrimenti lascia non selezionato."
            },
            "button": {
                "reset": "Reimposta",
                "submit": "Invia"
            },
            "validation": {
                "part": {
                    "required": "La parte è obbligatoria",
                    "max": "Deve essere esattamente di 16 caratteri"
                }
            },
            "message": {
                "subUserLimit": "Questo sotto-utente ha raggiunto il limite massimo di 10 parti URL.",
                "urlPartAlreadyTaken": "Questo URL del link musicale è già stato preso dal tuo account o da un altro account utente. Si prega di provare qualcos'altro."
            }
        },
        "message": {
            "addSuccess": "La parte URL del link musicale è stata aggiunta!",
            "updateSuccess": "La parte URL del link musicale è stata aggiornata!",
            "error": "Qualcosa è andato storto! Si prega di aggiornare la pagina e riprovare!"
        }
    }
};

export default musicLinkUrlPartsIT;